'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useContext, useMemo } from 'react';
import { useLFSearchParams } from '@services/useLFSearchParams';
import { useQueryOrg } from '@services/useQueryOrg';
import { RootStoreContext } from '@stores/rootStore';
import { keepPreviousData } from '@tanstack/react-query';
import { isPresent } from '@farmai-shared/LFUtils';
import type { ILabelOption } from '@app/_components/form-control/selects';
import type { MultiValue } from 'react-select';
type LabelLite = {
  id: string;
  label: string;
  color: string;
};
export const useActiveLabel = () => {
  const $ = _c(34);
  const {
    uiStore
  } = useContext(RootStoreContext);
  const {
    searchParams,
    setParams
  } = useLFSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    const raw = searchParams.getAll("filter[label_ids][]").flatMap(_temp);
    t0 = Array.from(new Set(raw.map(_temp2).filter(isPresent))).sort();
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const selectedIds = t0;
  let t1;
  if ($[2] !== selectedIds) {
    t1 = selectedIds.join(",");
    $[2] = selectedIds;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = ["useActiveLabels:list", t1];
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== selectedIds || $[7] !== uiStore) {
    t3 = () => (selectedIds.length ? uiStore.currentOrganization.fetchLabels({
      labelIds: selectedIds
    }) : Promise.resolve([])).then(_temp4);
    $[6] = selectedIds;
    $[7] = uiStore;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = {
      queryKey: t2,
      queryFn: t3,
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData
    };
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const {
    data: t5,
    isLoading
  } = useQueryOrg(t4);
  let t6;
  if ($[12] !== t5) {
    t6 = t5 === undefined ? [] : t5;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const labels = t6;
  let t7;
  if ($[14] !== labels) {
    t7 = labels.map(_temp5);
    $[14] = labels;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const labelOptions = t7;
  let t8;
  if ($[16] !== setParams) {
    t8 = ids => {
      if (!ids.length) {
        setParams([{
          key: "filter[label_ids][]",
          value: null
        }]);
        return;
      }
      setParams(ids.map(_temp6));
    };
    $[16] = setParams;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const writeIds = t8;
  let t9;
  if ($[18] !== setParams) {
    t9 = () => {
      setParams([{
        key: "filter[label_ids][]",
        value: null
      }]);
    };
    $[18] = setParams;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const clearLabels = t9;
  let t10;
  if ($[20] !== clearLabels || $[21] !== writeIds) {
    t10 = values => {
      const ids_0 = (values ?? []).map(_temp7).filter(Boolean);
      if (!ids_0.length) {
        clearLabels();
        return;
      }
      writeIds(Array.from(new Set(ids_0)).sort());
    };
    $[20] = clearLabels;
    $[21] = writeIds;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const handleLabelChange = t10;
  let t11;
  if ($[23] !== selectedIds || $[24] !== writeIds) {
    t11 = id_0 => {
      writeIds(selectedIds.filter(x => x !== id_0));
    };
    $[23] = selectedIds;
    $[24] = writeIds;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const removeLabel = t11;
  let t12;
  if ($[26] !== clearLabels || $[27] !== handleLabelChange || $[28] !== isLoading || $[29] !== labelOptions || $[30] !== labels || $[31] !== removeLabel || $[32] !== selectedIds) {
    t12 = {
      selectedIds,
      labels,
      labelOptions,
      isLoading,
      handleLabelChange,
      removeLabel,
      clearLabels
    };
    $[26] = clearLabels;
    $[27] = handleLabelChange;
    $[28] = isLoading;
    $[29] = labelOptions;
    $[30] = labels;
    $[31] = removeLabel;
    $[32] = selectedIds;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  return t12;
};
function _temp(s) {
  return s.split(",");
}
function _temp2(v) {
  return v.trim();
}
function _temp3(l) {
  return {
    id: l.id,
    label: l.name,
    color: l.color
  };
}
function _temp4(fetched) {
  return (fetched || []).map(_temp3);
}
function _temp5(l_0) {
  return {
    label: l_0.label,
    value: l_0.id,
    color: l_0.color
  };
}
function _temp6(id) {
  return {
    key: "filter[label_ids][]",
    value: id
  };
}
function _temp7(v_0) {
  return v_0 ? String(v_0.value) : "";
}